import { Button, ButtonGroup, Modal } from '@veneer/core';

interface ModalCheckoutShipping {
  onCloseShippingInfoTapped: () => void;
  showShippingModal: boolean;
}

const ModalCheckoutShipping = (props: ModalCheckoutShipping) => {
  return (
    <Modal
      id="shipping-modal"
      closeButton
      onClose={props.onCloseShippingInfoTapped}
      show={props.showShippingModal}
      title="Shipping info"
      footer={
        <ButtonGroup>
          <Button onClick={props.onCloseShippingInfoTapped}>Close</Button>
        </ButtonGroup>
      }
    >
      <p>
        This offer is only available to active Instant Ink customers, we’re shipping your HP Photobook to the Instant
        Ink address associated with your account.
      </p>
    </Modal>
  );
};

export default ModalCheckoutShipping;
